import type { SxProps, Theme } from '@mui/material';

/**
 * Outlined input styling for the Code Agent admin forms. The background is applied to the input
 * root (which has the rounded corners) instead of the TextField wrapper, so it no longer paints a
 * square box over the border or behind the floating label notch, and the border stays visible in
 * dark mode.
 */
export const codeAgentFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'rgb(15, 23, 42)' : '#ffffff'),
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: (theme) =>
        theme.palette.mode === 'dark' ? 'rgb(71, 85, 105)' : 'rgb(209, 213, 219)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: (theme) =>
        theme.palette.mode === 'dark' ? 'rgb(100, 116, 139)' : 'rgb(156, 163, 175)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3B82F6' },
    '& input, & select': {
      color: (theme) => (theme.palette.mode === 'dark' ? 'rgb(241, 245, 249)' : 'inherit'),
    },
  },
  '& .MuiInputLabel-root': {
    color: (theme) => (theme.palette.mode === 'dark' ? 'rgb(148, 163, 184)' : 'rgb(107, 114, 128)'),
    '&.Mui-focused': { color: '#3B82F6' },
  },
};
